import 'jquery-ui';

$('.js-datepicker').datepicker();
